import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FormControlProps } from 'react-bootstrap';
import styles from 'components/transactionEditor/ActionButtons.module.css';
import i18n from 'i18n';
import { EntityType, ObjectParamsItem, StateChangeType } from 'types/rest/assetCatalogTypes';
import BlazeInputDropdown, { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';

interface ObjectParamProps {
  id: number;
  paramValue: ObjectParamsItem;
  onChange: (name: string, value: string | null, index: number) => void;
  onDelete: (id: number) => void;
  onAdd: () => void;
  displayAdd: boolean;
  firstRow: boolean;
  dataParamsList: BlazeDropdownItem[];
  createEntityCallBack: (result: any) => void;
  setModalValue: (entityValue: string) => void;
  entityType: EntityType;
  stateChangeType: StateChangeType;
}

const ObjectParam = (props: ObjectParamProps) => {
  const handleChange = (e: React.FormEvent<FormControlProps>, index: number) => {
    const target = e.target as HTMLInputElement;
    props.onChange('value', target.value, index);
  };

  const onChangeDataParam = (selectedItem: BlazeDropdownItem, index: number) => {
    //If param is same, do not continue
    if (selectedItem.id === props.id) {
      return;
    }
    props.onChange('key', selectedItem.id as string, index);
  };

  const getSelectedDataParam = (): BlazeDropdownItem | null => {
    const type = props.dataParamsList.find(item => item.id === props.paramValue.key);
    return type ? type : null;
  };

  let colLabel = i18n.t('transactions:processingActions.modal.stateChange.valueToStore');
  switch (props.stateChangeType) {
    case 'INCREMENT_VALUE':
      colLabel = i18n.t('transactions:processingActions.modal.stateChange.increment');
      break;
    case 'UPDATE_OBJECT':
    case 'UPDATE_VALUE':
      colLabel = i18n.t('transactions:processingActions.modal.stateChange.updateToValue');
      break;
  }

  return (
    <Row id={String(props.id)} className="mb-3">
      <Col md={3}>
        <Form.Group>
          {props.firstRow && (
            <Form.Label>{i18n.t('transactions:processingActions.modal.stateChange.dataParameters')}</Form.Label>
          )}
          <BlazeInputDropdown
            id={'selectParamDropdown'}
            minDropdownMenuWidth={290}
            maxDropdownHeight={250}
            items={props.dataParamsList}
            onClick={item => onChangeDataParam(item, props.id)}
            selected={getSelectedDataParam()}
            isDefaultOptionSelectable={false}
            isSearchable={true}
            dropDownFooter={{
              entity: props.entityType === 'DATA_PARAMETER' ? 'Data Parameter' : 'Global Parameter',
              onClick: props.setModalValue,
              style: 'Text',
            }}
          ></BlazeInputDropdown>
        </Form.Group>
      </Col>
      <Col md={7}>
        <Form.Group>
          {props.firstRow && <Form.Label>{colLabel}</Form.Label>}
          <Form.Control
            as="input"
            autoComplete={'off'}
            onChange={(event: any) => handleChange(event, props.id)}
            placeholder={i18n.t('transactions:editor.value')}
            value={props.paramValue.value ? props.paramValue.value : ''}
          />
        </Form.Group>
      </Col>
      <Col md={2}>
        <div className={styles.actionButtons}>
          {!props.firstRow && (
            <Button
              id={'qa-btn-delete-' + props.id}
              onClick={() => props.onDelete(props.id)}
              variant="danger"
              className="btn-circular"
              title={i18n.t('transactions:processingActions.modal.stateChange.deleteParameter')}
            >
              <i className="icon-bzm-delete icon" />
            </Button>
          )}

          {props.displayAdd && (
            <Button
              onClick={props.onAdd}
              variant="secondary"
              className="btn-circular ml-4"
              title={i18n.t('transactions:processingActions.modal.stateChange.addParameter')}
            >
              <i className="icon icon-bzm-add icon-theme-blue" />
            </Button>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default ObjectParam;
